import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { ProductionNamespacesField, productionNamespacesValidation } from './ProductionNamespacesExt';

export const ProductionNamespacesFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ProductionNamespacesField',
    component: ProductionNamespacesField,
    validation: productionNamespacesValidation,
  }),
);